module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "careers"
    }
  }, [_c('div', {
    staticClass: "full-header"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "intro-text"
  }, [_c('h1', [_vm._v("Character, curiosity, ideas, oh, and capabilities help too.")]), _vm._v(" "), _c('p', [_vm._v("\n                At Label, we’re always seeking the best, local talent to join our team and work in our Southbury, CT headquarters. We have a very\n                fun, creative, and energetic office atmosphere and tackle new projects and challenges every day. Current job openings are "), _c('a', {
    attrs: {
      "href": "http://www.indeed.com/cmp/Label-Interactive-1/jobs",
      "target": "_blank",
      "role": "button"
    }
  }, [_vm._v("listed on Indeed")]), _vm._v(", or you can send your resume to "), _c('a', {
    attrs: {
      "target": "_top",
      "href": "mailto:jobs@labelinteractive.com?Subject=Resume"
    }
  }, [_vm._v("jobs@labelinteractive.com")]), _vm._v(".\n                When emailing, please show us your work! Include links to examples of your work online along with your resume. Please explain\n                exactly what your role was on each project. Developers, please include links to source code when possible.\n              ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-661f115e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Careers.vue
// module id = 588
// module chunks = 2